<template lang="">
  <div v-if="validProject" class="w-full">
    <div class="flex flex-row justify-between m-12 p-3">
      <div class="flex flex-row" style="width: 150px">
        <a @click="back">
          <ArrowCircleLeftIcon
            class="m-1 w-full h-12 rounded-sm label text-button text-xs"
          />
        </a>
      </div>
      <div class="text-3xl">Project fields</div>
      <div class="flex flex-row" style="width: 150px">
        <button
          v-if="$store.state.permissions.addProject"
          @click="addFieldModal.displayAddFieldModal = true"
          class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
        >
          Add Field
        </button>
      </div>
    </div>
    <div class="justify-center">
      <GoodTable
        :name="'projectfields'"
        :rows="fields"
        :columns="columns"
        :method1="editProjectfields"

      />
    </div>
    <!-- <GiveAccessModal
      v-if="displayUserModal"
      :selectedfields="fields"
      :projectId="id"
      :allfields="allfields"
      name="projects"
      @updatefields="updateParent"
      @close="displayUserModal = false"
    /> -->
    <EditAddFieldModal
        v-if="addFieldModal.displayAddFieldModal"
        :row="addFieldModal.row"
        :type="addFieldModal.type"
        @addField="addProjectField"
        @close="addFieldModal.displayAddFieldModal = false"
      />
  </div>
  <div v-else class="w-full">
    <NotFound />
  </div>
</template>
<script>
import Http, { OCR_ENDPOINTS } from "../request";
import GoodTable from "../components/GoodTable.vue";
// import GiveAccessModal from "../components/GiveAccessModal.vue";
import NotFound from "../views/404.vue";
import { ArrowCircleLeftIcon } from "@vue-hero-icons/outline";
import EditAddFieldModal from "../components/editAddFieldModal.vue";

export default {
  components: {
    GoodTable,
    // GiveAccessModal,
    NotFound,
    ArrowCircleLeftIcon,
    EditAddFieldModal
  },
  data() {
    return {
      displayUserModal: false,
      id: null,
      validProject: true,
      fieldsList:[],
      fields: [],
      allfields: [],
      addFieldModal:{ displayAddFieldModal: false, row:{}, type:{ name: 'Add', method: 'addField'} },
      columns: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Color",
          field: "color",
        },
        {
          label: "Actions",
          field: "actions",
          sortable: false,
        },
      ],
    };
  },

  created() {
    this.getIDfromURL();
    this.getProjectFields();
    // this.getAllfields();
  },

  methods: {
    back() {
      this.$router.push("/projects");
    },

    // updateParent(newData) {
    //   this.fields = newData;
    // },
    // getAllfields() {
    //   Http()
    //     .get(OCR_ENDPOINTS.fields, {
    //       params: {
    //         page: 0,
    //         size: 1000,
    //       },
    //       showLoader: false,
    //     })
    //     .then((response) => {
    //       this.allfields = response.data;
    //       // this.formatfields();
    //     })
    //     .finally(() => {});
    // },
    getProjectFields() {
      Http()
        .get(OCR_ENDPOINTS.projects + this.id + "/fields", {
          showLoader: true,
        })
        .then((response) => {
          console.log(response.data);
          this.fields = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },
    addProjectField(fields) {
      let newField = fields.map(value => this.createFieldRequest(value.name,value.color));
      Http()
        .post(OCR_ENDPOINTS.projects + this.id + "/fields", 
        newField
        )
        .then((response) => {
          response.data.forEach(data => {
            let isNew=true;
            this.fields.forEach(field=> {if(field.id == data.id){isNew=false}});
            if(isNew && response.status==200){
              this.fields.push(data);
              this.$toast.success("Field added succesfully");
            }
            else{
              this.$toast.error("Field already there. Please add a new field.");
            }
            

          });
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },
    editProjectfields(fields) {
      let newField = fields.map(value => this.createFieldRequest(value.name,value.color,value.id));
      
      Http()
        .patch(OCR_ENDPOINTS.projects + this.id + "/fields", 
          newField
        )
        .then((response) => {
          if(response.status==200){
            response.data.forEach(newField=>{
            const oldField = this.fields.find(({ id }) => id === newField.id);
            oldField.name=newField.name;
            oldField.color=newField.color; 
            })
            this.$toast.success("Field edited succesfully");
          }
          else{
            this.$toast.error("Could not edit field. Please try again.");
          }
         
      
         
        })
        .catch((error) => {
          this.$toast.error(error.response.data);
        })
        .finally(() => {});
    },
    getIDfromURL() {
      this.id = parseInt(window.location.pathname.split("/")[2]);
      Http()
        .get(OCR_ENDPOINTS.projects + `${this.id}`, {
          showLoader: false,
        })
        .then((response) => {
          this.validProject = true;
        })
        .catch((error) => {
          this.validProject = false;
        })
        .finally(() => {});
    },
    createFieldRequest (name,color,id) {
      return{
        fieldName:name,
        fieldColor: color,
        fieldId: id
      }
      }
  },
};
</script>
<style lang=""></style>
